import styled from 'styled-components'
import { orange, black, textMuted, darkGrey, lightGrey, white, surface2, border1 } from '@/theme/colors'
import { shadows, radii, layers } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Input, FieldLabel } from '@components/Field'

export const IdeaSelectContainer = styled.div`
	width: 100%;
`

export const IdeaLabel = styled(FieldLabel)`
	display: block;
	margin-bottom: 8px;
`

export const IdeaSelectWrapper = styled.div`
	position: relative;
	width: 100%;
`

export const IdeaInput = styled(Input)`
	padding-right: 40px;
	cursor: pointer;

	&:focus {
		cursor: text;
	}

	&:read-only {
		cursor: pointer;
	}
`

export const SearchIcon = styled.div`
	position: absolute;
	right: 12px;
	top: 50%;
	transform: translateY(-50%);
	color: ${textMuted};
	pointer-events: none;
	display: flex;
	align-items: center;
	justify-content: center;
`

/** Portal-positioned popover list on the overlay shadow. */
export const IdeaDropdown = styled.div<{ $top: number; $left: number; $width: number }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $left }) => $left}px;
	width: ${({ $width }) => $width}px;
	background: ${white};
	border: 1px solid ${border1};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.overlay};
	max-height: 300px;
	overflow-y: auto;
	z-index: ${layers.popover};

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: ${surface2};
		border-radius: ${radii.small};
	}

	&::-webkit-scrollbar-thumb {
		background: ${lightGrey};
		border-radius: ${radii.small};

		&:hover {
			background: ${darkGrey};
		}
	}
`

export const IdeaDropdownItem = styled.div<{ $isSelected: boolean }>`
	padding: 12px 16px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: 4px;
	background-color: ${props => (props.$isSelected ? `${orange}14` : 'white')};
	border-bottom: 1px solid ${border1};

	&:last-child {
		border-bottom: none;
	}

	&:hover {
		background-color: ${props => (props.$isSelected ? `${orange}26` : surface2)};
	}

	&:active {
		background-color: ${orange}26;
	}
`

export const IdeaName = styled.span`
	font-weight: 500;
	color: ${black};
	font-size: ${fontSizes.small};
`

export const IdeaDetails = styled.span`
	color: ${textMuted};
	font-size: ${fontSizes.caption};
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
`

export const IdeaCategory = styled.span`
	color: ${orange};
	font-size: ${fontSizes.micro};
	font-weight: 500;
`


